import { EditorAPIKey, EditorCoreApiKey } from '#packages/apis';
import {
  BreakpointsApi,
  isFluidEditor,
  setDesktopBreakpoint,
} from './breakpointsApi';
import { BreakpointsApiKey } from './publicApiKey';
import { BaseEntryScope, createEntryPoint } from '#packages/apilib';
import { BreakpointsStore } from './breakpointsStore';

export class Scope extends BaseEntryScope {
  store = this.declareStore(BreakpointsStore);
  editorAPI = this.useDependency(EditorAPIKey);
  editorCoreApi = this.useDependency(EditorCoreApiKey);
}

export const BreakpointsEntryPoint = createEntryPoint({
  name: 'EditorBreakpoints',
  Scope,
  publicApi({ contributeApi }) {
    contributeApi(BreakpointsApiKey, BreakpointsApi);
  },
  async initialize(scope: Scope) {
    await scope.editorCoreApi.hooks._dsIsReady.promise;

    if (isFluidEditor(scope)) {
      setDesktopBreakpoint(scope);
      // TODO: add afterPageAdd HOOK to set breakpoints for added page
    }
  },
});
